var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcTaskCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.08594,
    y: 3.25,
    width: 11.8333,
    height: 13.5,
    rx: 1.25,
    stroke: "#0895CB",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.95918 11.0062L7.88618 9.9332C7.88602 9.93304 7.88587 9.93289 7.88571 9.93273C7.83543 9.88196 7.77559 9.84163 7.70965 9.81409C7.64351 9.78645 7.57253 9.77222 7.50085 9.77222C7.42916 9.77222 7.35819 9.78645 7.29204 9.81409C7.2259 9.84172 7.1659 9.88221 7.11552 9.9332L7.25779 10.0738L7.11723 9.93149C7.06623 9.98187 7.02575 10.0419 6.99811 10.108C6.97048 10.1742 6.95625 10.2451 6.95625 10.3168C6.95625 10.3885 6.97048 10.4595 6.99811 10.5256C7.02566 10.5916 7.06598 10.6514 7.11675 10.7017C7.11691 10.7018 7.11707 10.702 7.11723 10.7022L8.57123 12.1562C8.78475 12.3697 9.13014 12.3697 9.34366 12.1562L13.0234 8.47993C13.0235 8.47978 13.0237 8.47963 13.0238 8.47948C13.0746 8.42919 13.1149 8.36935 13.1425 8.3034L12.9592 8.22683L13.1425 8.3034C13.1701 8.23725 13.1843 8.16628 13.1843 8.0946C13.1843 8.02291 13.1701 7.95194 13.1425 7.88579L12.9579 7.96289L13.1425 7.88579C13.115 7.82002 13.0748 7.76032 13.0242 7.71012C12.974 7.65953 12.9143 7.61934 12.8485 7.59186C12.7824 7.56423 12.7114 7.55 12.6397 7.55C12.5681 7.55 12.4971 7.56423 12.4309 7.59186C12.365 7.61941 12.3052 7.65973 12.2549 7.7105C12.2547 7.71066 12.2546 7.71082 12.2544 7.71098L8.95918 11.0062Z",
    fill: "#0895CB",
    stroke: "#0895CB",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTaskCheck);
export default __webpack_public_path__ + "static/media/ic_task_check.164ab63661a57939ef2c5064fec4cd07.svg";
export { ForwardRef as ReactComponent };